import ChallengeRoundOverview from '@components/challenge/challenge-round-overview';
import React from 'react';
export default function ChallengeRoundsOverview({ challenge, }) {
    return (React.createElement("div", { className: "flex flex-col desktop:bg-white desktop:px-4", "data-testid": "ChallengeRoundsOverview" }, challenge.rounds.map((round, index) => (React.createElement(ChallengeRoundOverview, { key: round.id, challenge: challenge, round: round, index: index })))));
}
